import { FormControl, TextField } from '@mui/material';
import React, { useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next';
import TPCheckbox from '../../TemplateProperties/TPCheckbox'

function VariableActionCountRenderer({ variableActionNode,submitChange }) {
  const { t } = useTranslation();
  const [incrementBy,setIncrementBy] = useState('');  
  const [resetBeforeUse,setResetBeforeUse] = useState(false);
  const [resetValue,setResetValue] = useState('')
  
  useEffect(() => {
  if(variableActionNode?.ACTION === 'COUNT'){
    if(!variableActionNode. hasOwnProperty('INCREMENT')){
      submitChange(null,null,{INCREMENT:'1'}) 
    }
    setIncrementBy(variableActionNode.INCREMENT || 1);
    setResetBeforeUse(variableActionNode.RESET_VALUE ? true : false)
    setResetValue(variableActionNode.RESET_VALUE);
  }
  },[variableActionNode])


  return (
    <div>
      <FormControl variant="outlined" className="width-100" size="small">
        <TextField
          size="small"
          label={t("LBL_INC_BY")}
          value={incrementBy}
          onChange={(e) => {
            setIncrementBy(e.target.value);
            submitChange(null,null,{INCREMENT:e.target.value})
          }}
        />
      </FormControl>
      <FormControl
        variant="outlined"
        className="width-100"
        size="small"
        style={{ marginTop: "0px" }}>
        <TPCheckbox
          label={t("BTN_RESET_BEFORE_USE")}
          checked={resetBeforeUse}
          handleCheck={(checked) => {
            setResetBeforeUse(checked);
          }}
        />
      </FormControl>
      { resetBeforeUse && <FormControl variant="outlined" className="width-100" size="small">
        <TextField
          size="small"
          label={t("LBL_RESET_VAL")}
          value={resetValue}
          onChange={(e) => {
            setResetValue(e.target.value);
            submitChange(null,null,{RESET_VALUE:e.target.value})
          }}
        />
      </FormControl>}
    </div>
  );
}

export default VariableActionCountRenderer